module.exports = __webpack_public_path__ + "img/8.ff272cc5.jpg";